/* eslint-disable react/prop-types */

import { Box, Card, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

export default function StatsCard({ title, value, icon, color }) {
    return (
        <Card
            sx={{
                height: "100%",
                p: 2.3,
                borderRadius: 3.5,
                border: "1px solid",
                borderColor: alpha(color, 0.16),
                background: `linear-gradient(135deg, #fff 0%, ${alpha(color, 0.035)} 100%)`,
                boxShadow: "0 14px 30px rgba(15,23,42,0.055)",
                transition: "all .2s ease",
                "&:hover": {
                    transform: "translateY(-3px)",
                    boxShadow: "0 18px 38px rgba(15,23,42,0.08)",
                },
            }}
        >
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1.5}>
                <Box>
                    <Typography
                        variant="body2"
                        sx={{
                            mb: 1,
                            color: "#64748b",
                            fontWeight: 850,
                        }}
                    >
                        {title}
                    </Typography>

                    <Typography
                        variant="h5"
                        fontWeight={950}
                        sx={{ color: "#0f172a", letterSpacing: "-0.3px" }}
                    >
                        {value}
                    </Typography>
                </Box>

                <Box
                    sx={{
                        width: 44,
                        height: 44,
                        borderRadius: 2.7,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: alpha(color, 0.12),
                        color,
                        flexShrink: 0,
                    }}
                >
                    {icon}
                </Box>
            </Stack>
        </Card>
    );
}